export default "/images/orange_arrow_blue_border.png?2adbb68d68e3539bcc073e817cdd6fb4";